module.exports = __webpack_public_path__ + "img/logo_delivery_bulk.3049033.svg";